import * as types from '../actions/actionTypes';
import {REST_URL} from '../constants';


export const currentInitiativePage = (state = {Data : [], TotalPageCount : 1, PageIndex : 1, PageSize : 50, Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_INITIATIVES : 
    case types.FETCH_INITIATIVES_REJECTED:
      return {Data : [], TotalPageCount : 1, PageIndex : 1, Loading : true, PageSize : 50};
    case types.FETCH_INITIATIVES_FULFILLED:
       return {...action.payload, Loading : false};
    default :
      return state;
  }
}

export const currentInitiative = (state = {Loading : true, Journals : [], Files : []}, action) => {
  switch(action.type){
    case types.FETCH_INITIATIVE : 
    case types.FETCH_INITIATIVE_REJECTED:
      return {Loading : true, Journals : [], Files : []};
    case types.FETCH_INITIATIVE_FULFILLED:
       return {...action.payload, Loading : false, Journals : []};
    case types.FETCH_INITIATIVE_JOURNALS :
    case types.FETCH_INITIATIVE_JOURNALS_REJECTED :
       return {...state, Loading : true, Journals : []};
    case types.FETCH_INITIATIVE_JOURNALS_FULFILLED :
       return {...state, Loading : false, Journals : action.payload};
    case types.RE_ASSIGN_INITIATIVE :
    case types.RE_ASSIGN_INITIATIVE_REJECTED :
       return state;
    case types.RE_ASSIGN_INITIATIVE_FULFILLED :
       return Object.assign({}, state, action.payload);  
    case types.SAVE_REWARD :
    case types.SAVE_REWARD_REJECTED :
       return state;
    case types.SAVE_REWARD_FULFILLED :
       return Object.assign({}, state, action.payload);  
    case types.SEND_INITIATIVE_OPINION_REQUEST :
    case types.SEND_INITIATIVE_OPINION_REQUEST_REJECTED :
       return state;
    case types.SEND_INITIATIVE_OPINION_REQUEST_FULFILLED :
       return Object.assign({}, state, action.payload);  
    default :
      return state;
  }
}


export const initiativeTypes = (state = {Types : [], Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_INITIATIVE_TYPES : 
    case types.FETCH_INITIATIVE_TYPES_REJECTED:
      return state;
    case types.FETCH_INITIATIVE_TYPES_FULFILLED:
       action.payload.forEach((t) => {
          t.label = t.Title; t.value = t.Id, t.className= 'bold-select-item';
       });
       return {Types : action.payload, Loading : false};
    case types.SAVE_INITIATIVE_TYPE:
    case types.SAVE_INITIATIVE_TYPE_REJECTED:
    case types.SAVE_INITIATIVE_TYPE_FULFILLED:
    default :
      return state;
  }
}

export const initiativeFilter = (state = { State: -1, UserId: -1, TypeId: -1, User: null, pageIndex: 1 }, action) => {
  switch(action.type){
    case types.SET_INITIATIVE_FILTER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

export const costCenters = (state = {CostCenters : [], Loading : true}, action) => {
  switch(action.type){
    case types.FETCH_COST_CENTERS : 
    case types.FETCH_COST_CENTERS_REJECTED:
      return state;
    case types.FETCH_COST_CENTERS_FULFILLED:
       action.payload.forEach((t) => {
          t.label = t.Title; t.value = t.Id, t.className= 'bold-select-item';
       });
       return {CostCenters : action.payload, Loading : false};
    default :
      return state;
  }
}


// WEBPACK FOOTER //
// ./reducers/initiativeReducer.js